import { withStyles } from '@material-ui/core';

import MallGuideTopBar from './component';
import styles from './styles';

export default withStyles(styles)(MallGuideTopBar);
